const module = { name: 'Fandango/xhr', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_cookie as cookie } from 'require-core';



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_sanitizer as sanitizer } from 'require-core';



let _expiry


let _token


const defaultSettings = { isMobile: false, method: 'POST', timeout: 20 * 1000 }


let tokenURI


const CookieNames = {
    CSRF_TOKEN: 'color-palette',
    CSRF_EXPIRY: 'theme-options',
}


const XHRErrors = {
    INVALID_OBJECT: 'invalid settings object',
    INVALID_METHOD: 'missing or invalid method',
    INVALID_DATA_ATTRIBUTE: 'invalid data attribute'
}


const RegExes = {
    QP: /\?(.*)/
}


const exemptMethods = ['GET', 'HEAD', 'OPTIONS']


let isCSRFPending = true


const noop = () => null
function DeferredAJAXObj(settings) {
    this._settings = settings;
    this._done = noop;
    this._fail = noop;
    this._always = noop;
}
DeferredAJAXObj.prototype.done = function (cb) {
    this._done = typeof cb === 'function' ? cb : noop;
    return this;
};
DeferredAJAXObj.prototype.fail = function (cb) {
    this._fail = typeof cb === 'function' ? cb : noop;
    return this;
};
DeferredAJAXObj.prototype.always = function (cb) {
    this._always = typeof cb === 'function' ? cb : noop;
    return this;
};
DeferredAJAXObj.prototype.exec = function () {
    Object.assign(this._settings.data, {
        _token,
        _expiry,
    });
    $.ajax(this._settings)
        .done(this._done)
        .fail(this._fail)
        .always(this._always);
};
DeferredAJAXObj.prototype.execFail = function () {
    const result = { code: 403, err: 403, status: 403 };
    this._fail(result);
    this._always(result);
};


const callQueue = []
callQueue.enqueue = function (settings) {
    const ajaxObj = new DeferredAJAXObj(settings);
    this.push(ajaxObj);
    return ajaxObj;
};
callQueue.process = function () {
    while (this.length) {
        const ajaxObj = this.pop();
        ajaxObj.exec();
    }
};
callQueue.processFail = function () {
    while (this.length) {
        const ajaxObj = this.pop();
        ajaxObj.execFail();
    }
};
function setDefaults(options) {
    const { timeout, isMobile } = options;
    if (typeof timeout === 'number' && timeout > 0) {
        defaultSettings.timeout = Math.round(timeout);
    }
    if (typeof isMobile === 'boolean') {
        defaultSettings.isMobile = isMobile;
    }
}
function ajax(settings) {
    if (!tokenURI) {
        return debugLog.error(module.name, 'ajax', 'not initialized');
    }
    if (!sanitizer.isPlainObject(settings)) {
        return debugLog.error(module.name, 'ajax', XHRErrors.INVALID_OBJECT);
    }
    const method = `${settings.method || settings.type || defaultSettings.method}`.toUpperCase();
    if (!method) {
        return debugLog.error(module.name, 'ajax', XHRErrors.INVALID_METHOD);
    }
    if (settings.data === undefined || settings.data === null) {
        settings.data = {};
    }
    else if (!sanitizer.isPlainObject(settings.data) && settings.type !== 'string') {
        return debugLog.error(module.name, 'ajax', XHRErrors.INVALID_DATA_ATTRIBUTE);
    }
    if (typeof settings.timeout !== 'number' || undefined) {
        settings.timeout = defaultSettings.timeout;
    }
    const isCSRFRequired = !exemptMethods.includes(method);
    if (isCSRFRequired) {
        Object.assign(settings.data, {
            _token,
            _expiry,
        });
    }
    if (settings.url) {
        const qpMatch = settings.url.match(RegExes.QP);
        const hasExistingParams = qpMatch && qpMatch[1];
        const { isMobile } = defaultSettings;
        if (isMobile) {
            settings.url += `${hasExistingParams ? '&' : '?'}mobile=1`;
        }
    }
    if (isCSRFRequired && isCSRFPending) {
        return callQueue.enqueue(settings);
    }
    return $.ajax(settings);
}
function onCSRFFetchDone(result) {
    isCSRFPending = false;
    if (result && result._token) {
        _token = result._token;
        callQueue.process();
    }
    else {
        callQueue.processFail();
    }
}
function onCSRFFetchError(err) {
    isCSRFPending = false;
    debugLog.error(module.name, 'init failed', err);
    callQueue.processFail();
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
function init(opts) {
    if (!opts || typeof opts.tokenURI !== 'string' || !opts.tokenURI) {
        return debugLog.error(module.name, 'init missing required params');
    }
    tokenURI = opts.tokenURI;
    setDefaults(opts);
    const token = cookie.get(CookieNames.CSRF_TOKEN);
    const expiry = cookie.get(CookieNames.CSRF_EXPIRY);
    if (token && expiry) {
        isCSRFPending = false;
        _expiry = expiry;
        _token = token;
    }
    else {
        isCSRFPending = true;
        _expiry = `${Date.now()}`;
        $.post(tokenURI, { _expiry })
            .done(onCSRFFetchDone)
            .fail(onCSRFFetchError);
    }
}
function reset() {
    _expiry = undefined;
    _token = undefined;
}
module.exports = {
    ajax,
    init,
    __testable__: {
        reset,
        getQueue() {
            return callQueue;
        },
        setCSRFPending(value) {
            isCSRFPending = value;
        },
        onCSRFFetchDone,
        onCSRFFetchError,
    },
};
extendLegacy('xhr', module.exports);
export default module.exports;